import { Form, Row, Col, Input } from 'antd'
import { FormInstance } from 'antd/lib/form'
import Styles from './style.module.scss'
import { imgFile } from './uploadimg'
import { formatStr } from '../../../../tools/util'

// 5.9.2版本隐藏
// const { RangePicker } = DatePicker
// const { Option } = Select

interface Props {
  form: FormInstance
  enterpriseLevelState: boolean
  licenceList: imgFile[]
  agreementList: imgFile[]
  onFieldsChange?: () => void
  validateStatus?: any
}
// 默认信息
const Businessinfo = (props: Props) => {
  const { form, validateStatus, onFieldsChange } = props
  const { enterpriseNature } = validateStatus || {}

  const itemLayout = {
    style: {
      marginTop: '10px',
      marginBottom: 0,
      border: 'none',
      backgroundColor: 'white',
      color: 'black',
      cursor: 'default',
    },
  }

  return (
    <Form
      // name='defaultinfo'
      form={form}
      onFieldsChange={onFieldsChange}
      labelAlign="right"
      colon={false}
      style={{ margin: '10px 0 0 0', padding: '0 10px 0 0' }}
      size="small"
    >
      <div className={Styles['table-msg']}>
        <Row>
          <Col span={4} className={Styles['item-label']}>
            <div className={Styles['item-require-label']}>企业名称</div>
          </Col>
          <Col span={20} className={Styles['item-input']}>
            <Form.Item
              name="enterpriseName"
              rules={[{ required: true, message: '请输入企业名称' }]}
            >
              <Input {...itemLayout} disabled />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={4} className={Styles['item-label']}>
            <div className={Styles['item-require-label']}>法定代表人</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item
              name="corporate"
              rules={[{ required: true, message: '请输入法定代表人' }]}
            >
              <Input {...itemLayout} disabled />
            </Form.Item>
          </Col>
          <Col span={4} className={Styles['item-right-label']}>
            <div className={Styles['item-require-label']}>经营状态</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item
              name="regStatus"
              rules={[
                { required: true, whitespace: true, message: '请选择经营状态' },
              ]}
            >
              <Input {...itemLayout} disabled />
              {/* <Select
                bordered={false}
                style={{
                  marginTop: '10px',
                  marginBottom: 0,
                  border: 0,
                  textAlign: 'center',
                }}
                allowClear
              >
                <Option value="存续">存续</Option>
                <Option value="在业">在业</Option>
                <Option value="吊销">吊销</Option>
                <Option value="注销">注销</Option>
                <Option value="迁入">迁入</Option>
                <Option value="迁出">迁出</Option>
                <Option value="停业">停业</Option>
                <Option value="清算">清算</Option>
              </Select> */}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={4} className={Styles['item-label']}>
            <div className={Styles['item-require-label']}>统一社会信用代码</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item
              name="uscc"
              rules={[{ required: true, message: '请输入统一社会信用代码' }]}
              getValueFromEvent={(e) => {
                return formatStr(e.target.value, 'TextNumber')
              }}
            >
              <Input {...itemLayout} disabled />
            </Form.Item>
          </Col>
          <Col span={4} className={Styles['item-right-label']}>
            <div className={Styles['item-require-label']}>成立日期</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item
              name="date"
              rules={[
                {
                  required: true,
                  type: 'object' as const,
                  message: '请选择成立日期',
                },
              ]}
            >
              <Input {...itemLayout} disabled />
              {/* <DatePicker style={{ width: '100%', border: 0 }} /> */}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={4} className={Styles['item-label']}>
            <div className={Styles['item-require-label']}>营业期限</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item
              name="allDate"
              rules={[
                {
                  required: true,
                  type: 'array' as const,
                  message: '请选择营业期限',
                },
              ]}
            >
              <Input {...itemLayout} disabled />
              {/* <RangePicker style={{ width: '100%', border: 0 }} /> */}
            </Form.Item>
          </Col>
          <Col span={4} className={Styles['item-right-label']}>
            <div className={Styles['item-require-label']}>注册资本</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item
              name="regCapital"
              rules={[{ required: true, message: '请输入注册资本' }]}
            >
              <Input {...itemLayout} disabled />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={4} className={Styles['item-label']}>
            <div className={Styles['item-require-label']}>公司性质</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item
              name="enterpriseNature"
              validateStatus={enterpriseNature ? 'warning' : ''}
              rules={[{ required: true, message: '请选择公司性质' }]}
            >
              <Input {...itemLayout} disabled />
              {/* <Select
                bordered={false}
                mode="multiple"
                style={{
                  marginTop: '10px',
                  marginBottom: 0,
                  border: 0,
                  textAlign: 'center',
                }}
                allowClear
              >
                <Select.Option value="1">生产型</Select.Option>
                <Select.Option value="2">服务型</Select.Option>
                <Select.Option value="3">商贸型</Select.Option>
              </Select> */}
            </Form.Item>
          </Col>
          <Col span={4} className={Styles['item-right-label']}>
            <div>实缴资本</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item
              name="paidCapital"
              rules={[{ message: '请输入实缴资本' }]}
            >
              <Input {...itemLayout} disabled />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={4} className={Styles['item-label']}>
            <div>参保人数</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item
              name="insNum"
              rules={[{ max: 10, message: '参保人数不超过10位' }]}
            >
              <Input {...itemLayout} disabled />
            </Form.Item>
          </Col>
          <Col span={4} className={Styles['item-right-label']}>
            <div className={Styles['item-require-label']}>纳税人识别号</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item
              name="taxNumber"
              rules={[{ required: true, message: '请输入纳税人识别号' }]}
              getValueFromEvent={(e) => {
                return formatStr(e.target.value, 'TextNumber')
              }}
            >
              <Input {...itemLayout} disabled />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={4} className={Styles['item-label']}>
            <div>曾用名</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item name="usedName" rules={[{ message: '请输入曾用名' }]}>
              <Input {...itemLayout} disabled />
            </Form.Item>
          </Col>
          <Col span={4} className={Styles['item-right-label']}>
            <div>纳税人资质</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item
              name="taxQualification"
              rules={[{ message: '请输入纳税人资质' }]}
            >
              <Input {...itemLayout} disabled />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={4} className={Styles['item-label']}>
            <div>英文名称</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item
              name="englishName"
              rules={[{ message: '请输入英文名称' }]}
              getValueFromEvent={(e) => {
                return formatStr(e.target.value, 'English')
              }}
            >
              <Input {...itemLayout} disabled />
            </Form.Item>
          </Col>
          <Col span={4} className={Styles['item-right-label']}>
            <div>登记机关</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item
              name="regAuthority"
              rules={[{ message: '请输入登记机关' }]}
            >
              <Input {...itemLayout} disabled />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={4} className={Styles['item-label']}>
            <div>工商注册号</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item name="regNo" rules={[{ message: '请输入工商注册号' }]}>
              <Input {...itemLayout} disabled />
            </Form.Item>
          </Col>
          <Col span={4} className={Styles['item-right-label']}>
            <div>组织机构代码</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item
              name="orgCode"
              rules={[{ message: '请输入组织机构代码' }]}
            >
              <Input {...itemLayout} disabled />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={4} className={Styles['item-label']}>
            <div className={Styles['item-require-label']}>行业</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item
              name="industry"
              rules={[
                { required: true, whitespace: true, message: '请选择行业' },
              ]}
            >
              <Input {...itemLayout} disabled />
              {/* <Select
                bordered={false}
                style={{
                  marginTop: '10px',
                  marginBottom: 0,
                  border: 0,
                  textAlign: 'center',
                }}
                allowClear
              >
                <Option value="能源行业（电力、轨道、热电、风电）">
                  能源行业（电力、轨道、热电、风电）
                </Option>
                <Option value="制造业">制造业</Option>
                <Option value="采矿业">采矿业</Option>
                <Option value="建筑业">建筑业</Option>
                <Option value="信息传输、计算机服务和软件业">
                  信息传输、计算机服务和软件业
                </Option>
                <Option value="交通运输、仓储物流业">
                  交通运输、仓储物流业
                </Option>
                <Option value="科学研究和技术服务业">
                  科学研究和技术服务业
                </Option>
                <Option value="租赁和商务服务业">租赁和商务服务业</Option>
                <Option value="文化、体育和娱乐业">文化、体育和娱乐业</Option>
                <Option value="教育业">教育业</Option>
              </Select> */}
            </Form.Item>
          </Col>
          <Col span={4} className={Styles['item-label']}>
            <div>人员规模</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item
              name="peopleNum"
              rules={[{ max: 10, message: '人员规模不超过10位' }]}
            >
              <Input {...itemLayout} disabled />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={4} className={Styles['item-label']}>
            <div className={Styles['item-require-label']}>注册地址</div>
          </Col>
          <Col span={20} className={Styles['item-input']}>
            <Form.Item
              name="regAddress"
              rules={[{ required: true, message: '请输入注册地址' }]}
            >
              <Input
                style={{
                  marginTop: '10px',
                  marginBottom: 0,
                  textAlign: 'left',
                  border: 'none',
                  backgroundColor: 'white',
                  color: 'black',
                }}
                disabled
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col
            span={4}
            style={{ height: '150px' }}
            className={Styles['item-label']}
          >
            <div
              style={{ marginTop: '50px' }}
              className={Styles['item-require-label']}
            >
              经营范围
            </div>
          </Col>
          <Col
            span={20}
            style={{ height: '150px' }}
            className={Styles['item-input']}
          >
            <Form.Item
              name="businessScope"
              rules={[{ required: true, message: '请输入经营范围' }]}
            >
              {/* <Input type='textarea' {...itemLayout}  /> */}
              <Input.TextArea
                {...itemLayout}
                style={{
                  height: '150px',
                  textAlign: 'left',
                  backgroundColor: 'white',
                  color: 'black',
                  cursor: 'default',
                  resize: 'none',
                }}
                disabled
              />
            </Form.Item>
          </Col>
        </Row>
      </div>
    </Form>
  )
}

export default Businessinfo
import { Form, Row, Col, Input } from 'antd'
import { FormInstance } from 'antd/lib/form'
import Styles from './style.module.scss'
import { imgFile } from './uploadimg'
import { formatStr } from '../../../../tools/util'

// 5.9.2版本隐藏
// const { RangePicker } = DatePicker
// const { Option } = Select

interface Props {
  form: FormInstance
  enterpriseLevelState: boolean
  licenceList: imgFile[]
  agreementList: imgFile[]
  onFieldsChange?: () => void
  validateStatus?: any
}
// 默认信息
const Businessinfo = (props: Props) => {
  const { form, validateStatus, onFieldsChange } = props
  const { enterpriseNature } = validateStatus || {}

  const itemLayout = {
    style: {
      marginTop: '10px',
      marginBottom: 0,
      border: 'none',
      backgroundColor: 'white',
      color: 'black',
      cursor: 'default',
    },
  }

  return (
    <Form
      // name='defaultinfo'
      form={form}
      onFieldsChange={onFieldsChange}
      labelAlign="right"
      colon={false}
      style={{ margin: '10px 0 0 0', padding: '0 10px 0 0' }}
      size="small"
    >
      <div className={Styles['table-msg']}>
        <Row>
          <Col span={4} className={Styles['item-label']}>
            <div className={Styles['item-require-label']}>企业名称</div>
          </Col>
          <Col span={20} className={Styles['item-input']}>
            <Form.Item
              name="enterpriseName"
              rules={[{ required: true, message: '请输入企业名称' }]}
            >
              <Input {...itemLayout} disabled />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={4} className={Styles['item-label']}>
            <div className={Styles['item-require-label']}>法定代表人</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item
              name="corporate"
              rules={[{ required: true, message: '请输入法定代表人' }]}
            >
              <Input {...itemLayout} disabled />
            </Form.Item>
          </Col>
          <Col span={4} className={Styles['item-right-label']}>
            <div className={Styles['item-require-label']}>经营状态</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item
              name="regStatus"
              rules={[
                { required: true, whitespace: true, message: '请选择经营状态' },
              ]}
            >
              <Input {...itemLayout} disabled />
              {/* <Select
                bordered={false}
                style={{
                  marginTop: '10px',
                  marginBottom: 0,
                  border: 0,
                  textAlign: 'center',
                }}
                allowClear
              >
                <Option value="存续">存续</Option>
                <Option value="在业">在业</Option>
                <Option value="吊销">吊销</Option>
                <Option value="注销">注销</Option>
                <Option value="迁入">迁入</Option>
                <Option value="迁出">迁出</Option>
                <Option value="停业">停业</Option>
                <Option value="清算">清算</Option>
              </Select> */}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={4} className={Styles['item-label']}>
            <div className={Styles['item-require-label']}>统一社会信用代码</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item
              name="uscc"
              rules={[{ required: true, message: '请输入统一社会信用代码' }]}
              getValueFromEvent={(e) => {
                return formatStr(e.target.value, 'TextNumber')
              }}
            >
              <Input {...itemLayout} disabled />
            </Form.Item>
          </Col>
          <Col span={4} className={Styles['item-right-label']}>
            <div className={Styles['item-require-label']}>成立日期</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item
              name="date"
              rules={[
                {
                  required: true,
                  type: 'object' as const,
                  message: '请选择成立日期',
                },
              ]}
            >
              <Input {...itemLayout} disabled />
              {/* <DatePicker style={{ width: '100%', border: 0 }} /> */}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={4} className={Styles['item-label']}>
            <div className={Styles['item-require-label']}>营业期限</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item
              name="allDate"
              rules={[
                {
                  required: true,
                  type: 'array' as const,
                  message: '请选择营业期限',
                },
              ]}
            >
              <Input {...itemLayout} disabled />
              {/* <RangePicker style={{ width: '100%', border: 0 }} /> */}
            </Form.Item>
          </Col>
          <Col span={4} className={Styles['item-right-label']}>
            <div className={Styles['item-require-label']}>注册资本</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item
              name="regCapital"
              rules={[{ required: true, message: '请输入注册资本' }]}
            >
              <Input {...itemLayout} disabled />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={4} className={Styles['item-label']}>
            <div className={Styles['item-require-label']}>公司性质</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item
              name="enterpriseNature"
              validateStatus={enterpriseNature ? 'warning' : ''}
              rules={[{ required: true, message: '请选择公司性质' }]}
            >
              <Input {...itemLayout} disabled />
              {/* <Select
                bordered={false}
                mode="multiple"
                style={{
                  marginTop: '10px',
                  marginBottom: 0,
                  border: 0,
                  textAlign: 'center',
                }}
                allowClear
              >
                <Select.Option value="1">生产型</Select.Option>
                <Select.Option value="2">服务型</Select.Option>
                <Select.Option value="3">商贸型</Select.Option>
              </Select> */}
            </Form.Item>
          </Col>
          <Col span={4} className={Styles['item-right-label']}>
            <div>实缴资本</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item
              name="paidCapital"
              rules={[{ message: '请输入实缴资本' }]}
            >
              <Input {...itemLayout} disabled />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={4} className={Styles['item-label']}>
            <div>参保人数</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item
              name="insNum"
              rules={[{ max: 10, message: '参保人数不超过10位' }]}
            >
              <Input {...itemLayout} disabled />
            </Form.Item>
          </Col>
          <Col span={4} className={Styles['item-right-label']}>
            <div className={Styles['item-require-label']}>纳税人识别号</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item
              name="taxNumber"
              rules={[{ required: true, message: '请输入纳税人识别号' }]}
              getValueFromEvent={(e) => {
                return formatStr(e.target.value, 'TextNumber')
              }}
            >
              <Input {...itemLayout} disabled />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={4} className={Styles['item-label']}>
            <div>曾用名</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item name="usedName" rules={[{ message: '请输入曾用名' }]}>
              <Input {...itemLayout} disabled />
            </Form.Item>
          </Col>
          <Col span={4} className={Styles['item-right-label']}>
            <div>纳税人资质</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item
              name="taxQualification"
              rules={[{ message: '请输入纳税人资质' }]}
            >
              <Input {...itemLayout} disabled />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={4} className={Styles['item-label']}>
            <div>英文名称</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item
              name="englishName"
              rules={[{ message: '请输入英文名称' }]}
              getValueFromEvent={(e) => {
                return formatStr(e.target.value, 'English')
              }}
            >
              <Input {...itemLayout} disabled />
            </Form.Item>
          </Col>
          <Col span={4} className={Styles['item-right-label']}>
            <div>登记机关</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item
              name="regAuthority"
              rules={[{ message: '请输入登记机关' }]}
            >
              <Input {...itemLayout} disabled />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={4} className={Styles['item-label']}>
            <div>工商注册号</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item name="regNo" rules={[{ message: '请输入工商注册号' }]}>
              <Input {...itemLayout} disabled />
            </Form.Item>
          </Col>
          <Col span={4} className={Styles['item-right-label']}>
            <div>组织机构代码</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item
              name="orgCode"
              rules={[{ message: '请输入组织机构代码' }]}
            >
              <Input {...itemLayout} disabled />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={4} className={Styles['item-label']}>
            <div className={Styles['item-require-label']}>行业</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item
              name="industry"
              rules={[
                { required: true, whitespace: true, message: '请选择行业' },
              ]}
            >
              <Input {...itemLayout} disabled />
              {/* <Select
                bordered={false}
                style={{
                  marginTop: '10px',
                  marginBottom: 0,
                  border: 0,
                  textAlign: 'center',
                }}
                allowClear
              >
                <Option value="能源行业（电力、轨道、热电、风电）">
                  能源行业（电力、轨道、热电、风电）
                </Option>
                <Option value="制造业">制造业</Option>
                <Option value="采矿业">采矿业</Option>
                <Option value="建筑业">建筑业</Option>
                <Option value="信息传输、计算机服务和软件业">
                  信息传输、计算机服务和软件业
                </Option>
                <Option value="交通运输、仓储物流业">
                  交通运输、仓储物流业
                </Option>
                <Option value="科学研究和技术服务业">
                  科学研究和技术服务业
                </Option>
                <Option value="租赁和商务服务业">租赁和商务服务业</Option>
                <Option value="文化、体育和娱乐业">文化、体育和娱乐业</Option>
                <Option value="教育业">教育业</Option>
              </Select> */}
            </Form.Item>
          </Col>
          <Col span={4} className={Styles['item-label']}>
            <div>人员规模</div>
          </Col>
          <Col span={8} className={Styles['item-input']}>
            <Form.Item
              name="peopleNum"
              rules={[{ max: 10, message: '人员规模不超过10位' }]}
            >
              <Input {...itemLayout} disabled />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={4} className={Styles['item-label']}>
            <div className={Styles['item-require-label']}>注册地址</div>
          </Col>
          <Col span={20} className={Styles['item-input']}>
            <Form.Item
              name="regAddress"
              rules={[{ required: true, message: '请输入注册地址' }]}
            >
              <Input
                style={{
                  marginTop: '10px',
                  marginBottom: 0,
                  textAlign: 'left',
                  border: 'none',
                  backgroundColor: 'white',
                  color: 'black',
                }}
                disabled
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col
            span={4}
            style={{ height: '150px' }}
            className={Styles['item-label']}
          >
            <div
              style={{ marginTop: '50px' }}
              className={Styles['item-require-label']}
            >
              经营范围
            </div>
          </Col>
          <Col
            span={20}
            style={{ height: '150px' }}
            className={Styles['item-input']}
          >
            <Form.Item
              name="businessScope"
              rules={[{ required: true, message: '请输入经营范围' }]}
            >
              {/* <Input type='textarea' {...itemLayout}  /> */}
              <Input.TextArea
                {...itemLayout}
                style={{
                  height: '150px',
                  textAlign: 'left',
                  backgroundColor: 'white',
                  color: 'black',
                  cursor: 'default',
                  resize: 'none',
                }}
                disabled
              />
            </Form.Item>
          </Col>
        </Row>
      </div>
    </Form>
  )
}

export default Businessinfo
